import { Menu, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles, useTheme, withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import FileTypeCancel from "components/common/FileTypeCancel";
import InfoIconButton from "components/common/InfoIconButton";
import { statusReportServiceId, STATUS_PROCESS } from "libs/configs/constant";
import { STATUS_REPORT_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { addSmartCancel, getOldDataSmartFormList } from "redux/modules/cancelVisaSlice";
import { addSmartFromStatusReport, getPartFormDetail, selectRequestDocs, setStep } from "redux/modules/statusReportSlice";
import FileService from "services/FileService";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
  },
  body: {
    border: "0px solid",
    fontSize: 16,
  },
}))(TableCell);


const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      // backgroundColor: theme.palette.background.main,
    },
  },
}))(TableRow);


const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
  },
  tableTitle: {
    fontWeight: "bold",
    color: "#172b4d",
    marginLeft: 16,
  },
  table: {
    minWidth: 700,
    marginTop: 15,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  wrapTitleContent: {
    width: 36,
    display: "flex",
    justifyContent: "center",
    marginRight: 3,
    marginLeft: 8,
  },
  badge: {
    display: "flex",
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: "#feb969",
    marginRight: 8,
    textAlign: "center",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
}));



function UploadButton({ id, onChange, title, disabled }) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          fullWidth={false}
          style={{ width: 82, backgroundColor: "#00D0FF", fontWeight: "bold" }}
          variant="contained"
          color="info"
          size="small"
          disabled={disabled}
        >
          + ADD
        </ColorButton>
      </label>
    </div>
  );
}

const InfoButton = ({ id, onRemoveAll, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <InfoIconButton
        aria-controls={`info-menu-${id}`}
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
      />
      <Menu
        id={`info-menu-${id}`}
        anchorEl={anchorEl}
        keepMounted={false}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={1}
      >
        <MenuItem
          onClick={async () => {
            handleClose();
            onRemoveAll();
          }}
        >
          Remove all files
        </MenuItem>
      </Menu>
    </>
  );
};

export default function StatusReportB() {
  const classes = useStyles();
  const { showLoading, hideLoading } = useModalLoading();
  const theme = useTheme();
  const reqDocs = useSelector(selectRequestDocs);
  const dispatch = useDispatch();
  const { personalID } = useSelector((state) => state.personal.detail);
  const { smartDetail, partForm, currentDraftId, currentDraftDetail, docRequests, oldData } = useSelector((state) => state.statusReport);
  const history = useHistory();
  const [messages, setMessages] = useState([]);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get('draftId');

  console.log(smartDetail);
  // useEffect(() => {
  //     async function fetchData() {
  //         await dispatch(getRequestDoc({ smartserviceId: currentDraftDetail?.smartserviceReferId }));
  //     }
  //     fetchData();
  // }, [dispatch])

  useEffect(() => {
    validateFiles();
  }, [currentDraftDetail])

  const handleOnChangeFile = async (event, row) => {
    try {
      showLoading();

      // console.log(row);
      // return;
      const response = await FileService.uploadFile({
        file: event.target.files[0],
        FileID: null,
        Status: true,
      });

      const fileId = response.results?.fileID;

      const fileRequest = getFileRequest(fileId, row);


      const details = getDetailRequest(fileId, row);

      const body = {
        draftId: currentDraftId,
        smartserviceId: statusReportServiceId,
        personalId: personalID,
        smartserviceReferId: smartDetail.smartserviceId,
        survey: null,
        visaissuance: null,
        // fileDocument: [fileRequest],
        detail: [details]
      };

      await dispatch(addSmartFromStatusReport(body))
      await dispatch(getPartFormDetail({ personalId: personalID, draftId: currentDraftId }));
      // await dispatch(getOldDataSmartFormList({ personalId: personalID, draftId: draftId }));
      event.target.value = "";
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }


  const getFileRequest = (fileId, row) => {
    const body = {
      uploadfileID: null,
      personalID: personalID,
      typedocId: row.typedocID,
      documentID: row.documentID,
      fileID: fileId,
      status: true,
    }
    return body;
  }

  const getDetailRequest = (fileId, row) => {
    const body = {
      smartId: null,
      partfromId: null,
      configsmartId: null,
      linkTable: '',
      value: null,
      configConditionVisaId: null,
      configDocumentRequiredID: row.configDocumentRequiredID,
      ocRtext: null, // อ่านจาก 
      fileID: fileId,
      status: true,
    }
    return body;
  }

  const validateFiles = () => {
    const _mgs = [];
    const fileUploaded = currentDraftDetail?.fileDocument;
    const fileRequired = docRequests.filter(f => f.isRequired);


    fileRequired.forEach(f => {
      const file = fileUploaded.find(x => x.documentID === f.documentID);
      if (!file) {
        setMessages([...messages, f])
        _mgs.push(f)
      }
    })

    if (_mgs.length > 0) {
      setMessages([..._mgs]);
      return false;
    }
    else {
      setMessages([]);
      return true;
    }
  }

  const removeAll = async (row) => {
    try {
      showLoading();
      const configDocumentRequiredID = row.configDocumentRequiredID;
      const files = currentDraftDetail.fileDocument.filter(x => x.configDocumentRequiredID === configDocumentRequiredID);

      const fileRequests = files.map(x => {
        return {
          uploadfileID: x.uploadfileID,
          personalID: personalID,
          typedocId: x.typedocId,
          documentID: x.documentID,
          fileID: x.fileID,
          status: false,
        }
      })

      const detaills = files.map(x => {
        return {
          smartId: x.smartId,
          partfromId: null,
          configsmartId: null,
          linkTable: '',
          value: null,
          configConditionVisaId: null,
          configDocumentRequiredID: row.configDocumentRequiredID,
          ocRtext: null, // อ่านจาก 
          fileID: x.fileId,
          status: false,
        }
      })

      console.log(detaills);
      const body = {
        draftId: currentDraftId,
        smartserviceId: statusReportServiceId,
        personalId: personalID,
        smartserviceReferId: smartDetail.smartserviceId,
        survey: null,
        visaissuance: null,
        // fileDocument: fileRequests,
        detail: detaills
      };

      await dispatch(addSmartFromStatusReport(body))
      await dispatch(getPartFormDetail({ personalId: personalID, draftId: currentDraftId }));
      hideLoading();
    } catch (error) {
      hideLoading();
    }

  }

  const removeFile = async (file, row) => {
    try {
      showLoading();
      const fileRequest = {
        uploadfileID: file.uploadfileID,
        personalID: personalID,
        typedocId: file.typedocID,
        documentID: file.documentID,
        fileID: file.fileId,
        status: false,
      }

      const detail = {
        smartId: file.smartId,
        partfromId: null,
        configsmartId: null,
        linkTable: '',
        value: null,
        configConditionVisaId: null,
        configDocumentRequiredID: row.configDocumentRequiredID,
        ocRtext: null, // อ่านจาก 
        fileID: file.fileId,
        status: false,
      }


      const body = {
        draftId: currentDraftId,
        smartserviceId: statusReportServiceId,
        personalId: personalID,
        smartserviceReferId: smartDetail.smartserviceId,
        survey: null,
        visaissuance: null,
        // fileDocument: [fileRequest],
        detail: [detail]
      };
      await dispatch(addSmartFromStatusReport(body))
      await dispatch(getPartFormDetail({ personalId: personalID, draftId: currentDraftId }));
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }

  const viewFile = async (file) => {
    openFileById(file.fileID)
  }

  const getAttachments = (row) => {
    const files = currentDraftDetail?.fileDocument;

    if (files) {
      return files.filter(x => x.configDocumentRequiredID === row.configDocumentRequiredID)
    }
    return [];
  }

  const sendCancel = async () => {
    try {
      const filesValid = validateFiles();
      if (filesValid) {
        if (!window.confirm('Do you want to update status report this visa?')) { return; }
        showLoading();
        await dispatch(addSmartCancel(currentDraftId))
        hideLoading();
        history.push('/');
        dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_B));
      }
    } catch (error) {
      hideLoading();
    }
  }


  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <ContentTitle
          subTitle="Smart Visa Status Report Request Form"
          title="Status Report Request Form"
        />


        {messages.map((m, index) => {
          return (
            <Alert key={index} severity="error">
              {m.documentName} Document is required.
            </Alert>
          )
        })}

        {
          Object.entries(reqDocs).map(([key, value], index) => (
            <Table key={key} className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={2}>
                    <Typography variant="h6" className={classes.tableTitle}>
                      {key}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell align="center" width={180} colSpan={2}>
                    File Upload ( PDF, JPG )
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  value.map((row, index) => (
                    <>
                      <StyledTableRow
                        key={row.configDocumentRequiredID}
                        style={{
                          backgroundColor:
                            index % 2 !== 0
                              ? theme.palette.background.main
                              : theme.palette.common.white,
                        }}
                      >
                        <StyledTableCell colSpan={2}>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <div style={{ display: "flex" }}>
                              <div className={classes.wrapTitleContent}>
                                <div className={classes.badge}>
                                  {index + 1}
                                </div>
                              </div>
                              <div style={{ display: "flex", flex: 1 }}>
                                <Typography>{row.documentName}</Typography>
                              </div>
                            </div>
                          </div>
                        </StyledTableCell>
                        <StyledTableCell align="center" style={{ width: 100 }}>
                          <UploadButton
                            disabled={draftId && oldData?.statausID != STATUS_PROCESS.Draft}
                            id={row.documentID}
                            onClick={() => { }}
                            onChange={(event) => { handleOnChangeFile(event, row) }}
                          />
                        </StyledTableCell>
                        <StyledTableCell align="center" style={{ width: 50 }}>
                          <InfoButton
                            disabled={draftId && oldData?.statausID != STATUS_PROCESS.Draft}
                            id={row.documentID}
                            onRemoveAll={() => removeAll(row)} />
                        </StyledTableCell>
                      </StyledTableRow>

                      {
                        getAttachments(row).map((file, index) => (
                          <>
                            <StyledTableRow
                              style={{
                                backgroundColor:
                                  index % 2 !== 0
                                    ? theme.palette.background.main
                                    : theme.palette.common.white,
                              }}
                            >
                              <StyledTableCell
                                align="center"
                                style={{ borderRight: 0 }}
                              >
                                <div style={{ display: "flex", marginLeft: 58 }}>
                                  <FileTypeCancel title="Document file" file={file} />
                                </div>
                              </StyledTableCell>

                              <StyledTableCell
                                align="center"
                                style={{ borderLeft: 0 }}
                              >


                                <ColorButton
                                  disabled={draftId && oldData?.statausID != STATUS_PROCESS.Draft}
                                  fullWidth={false}
                                  style={{ width: 82, fontWeight: "bold" }}
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  onClick={() => removeFile(file, row)}
                                >
                                  Remove
                                </ColorButton>
                              </StyledTableCell>
                              <StyledTableCell align="center">
                                <ColorButton
                                  fullWidth={false}
                                  style={{ width: 82, fontWeight: "bold" }}
                                  variant="contained"
                                  color="secondary"
                                  size="small"
                                  onClick={() => viewFile(file)}
                                >
                                  View
                                </ColorButton>
                              </StyledTableCell>
                              <StyledTableCell></StyledTableCell>
                            </StyledTableRow>
                          </>
                        ))
                      }
                    </>
                  ))
                }
              </TableBody>
            </Table>
          ))
        }
        <div
          style={{
            marginTop: 44,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          {
            draftId &&
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="outlined"
              color="primary"
              type="button"
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setStep(STATUS_REPORT_STEP.STATUS_REPORT_STEP_A));

              }}
            >
              Back
            </ColorButton>
          }

          <ColorButton
            style={{ height: 40, width: 125, marginLeft: 20 }}
            variant="contained"
            color="primary"
            type="submit"
            disabled={draftId && oldData?.statausID != STATUS_PROCESS.Draft}
            onClick={() => {
              window.scrollTo(0, 0);
              sendCancel();
            }}
          >
            Sent
          </ColorButton>
        </div>

      </div>
    </Paper>
  )
}
